export default {
    getHeaderFields: state => state.headerFields,
    getSearchFields: state => state.searchFields,
    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions
}
